/**
 * What a coach agrees to before BAM IQ works with a player's plan (D122,
 * gate G3). Shown in the app the first time they attach a plan; the server
 * records the version and checks it on every turn and every save.
 *
 * DRAFT for Coleman's and counsel's review (G1, PQ-21) before any coach sees
 * it. It lists exactly what api/_bamiq/attach.js planText() sends; if that
 * changes, this text and its version change with it.
 */
export const BAMIQ_PLAYER_CONSENT_VERSION = 1;

export const BAMIQ_PLAYER_CONSENT_TITLE = "Use BAM IQ with your players' plans?";

export const BAMIQ_PLAYER_CONSENT_COPY = "When you attach a player's plan, BAM IQ sends parts of it to our AI provider (Anthropic) so it can discuss the plan with you and suggest changes: the role, position, level, superpowers, rate limiters, areas of the game, KPIs and roadmap items with their target dates. The player's name is replaced before anything is sent. Mind notes, session logs and check-in answers are never sent, and nothing is used to train AI models. BAM IQ only proposes changes: nothing is saved to a plan unless you tap Save. You can withdraw this anytime by emailing support@byanymeanscoaches.com.";
